import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, ButtonGroup, Glyphicon } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "api/auth/users"

class AccountOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.getUsers = this.getUsers.bind(this)
        this.state = {
            users: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: FETCH_URL // To know where to fetch (to refresh accounts) if a company is deleted
        }
    }

    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/auth/user/${id}`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete account with id: ${id}`)
                Api.print(response)
                this.getUsers(this.state.currentFetchUrl) // Update the users list
            })
        }
    }

    getUsers(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handleClick).then(response => {
            this.setState({ pagination: response.pagination }) // Pagination object
            return response.data.json() // Data -> Users object
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ users: objectData.users }) // Users object

        })
    }

    componentDidMount() {
        this.getUsers(FETCH_URL)
    }

    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getUsers(fetchUrl)
        this.setState({ currentFetchUrl: fetchUrl })
    }

    render() {
        let users = this.state.users
        return (
            <div>
                <LinkContainer to="/admin/accounts/toevoegen">
                    <Button>
                        Account toevoegen
                    </Button>
                </LinkContainer>
                <br /><br />
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Rol</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users !== undefined ? users.map((user) => {
                            let editUrl = `/admin/accounts/bewerken/${user.id}`
                            return (<tr key={user.id}>
                                <td>{user.userName}</td>
                                <td>{user.role}</td>
                                <td>
                                    <ButtonGroup>
                                        <LinkContainer to={editUrl}>
                                            <Button bsSize="xsmall" className="edit">
                                                <Glyphicon glyph="pencil" />
                                            </Button>
                                        </LinkContainer>
                                        <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(user.id)}>
                                            <Glyphicon glyph="remove" />
                                        </Button>
                                    </ButtonGroup></td>
                            </tr >)
                        }) : null}
                    </tbody>
                </Table>
                <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default AccountOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Accounts/Overview.js